
















import { Vue, Component } from 'vue-property-decorator'
import { GradeBookInterface } from '@/interface/BaseInterface'
import getApi from '@/api'

const gradeBookApi = getApi('gradeBook')
@Component
export default class CourseGrades extends Vue {
  gradeBooks: GradeBookInterface[] = []

  async init() {
    try {
      this.gradeBooks = await gradeBookApi.getGradeBooks({
        courseId: this.courseId
      })
    } catch (error) {
      console.log(error)
    }
  }

  created() {
    this.init()
  }
}
